import React       from 'react';
import PropTypes   from 'prop-types';
import QueryString from 'query-string';

import { Spinner }       from '../../common/spinner/spinner';
import { setCtxField }   from '../../../context/ctx-actions';
import { useGlobalCtx }  from '../../../context/ctx-hook';
import * as NetworkCalls from '../../../network/network-calls';
import { storeAuthTokens, startTokenRefreshTimer } from '../../../helpers/token-refresh';
import * as S            from './login-page.module.scss';


const LoginPage = ({history: {push}, location: {search}}) => {
  const {state, globalDispatch} = useGlobalCtx();
  const [loginInProg, setloginInProg] = React.useState(false);

  const SEARCH = QueryString.stringify({
    client_id:     process.env.REACT_APP_CLIENT_ID,
    redirect_uri:  process.env.REACT_APP_REDIRECT_URL,
    response_type: 'code'
  });

  const getAuthToken = React.useCallback(async (code, params) => {
    try {
      setloginInProg(true);

      const POST_LOGIN = localStorage.getItem('postLogin');
      const {data}     = await NetworkCalls.getUserToken(code);

      // Store tokens and start refresh timer
      storeAuthTokens(data);
      startTokenRefreshTimer();

      // Update global login state
      globalDispatch(setCtxField('isLoggedIn', true));

      if (POST_LOGIN) {
        const {search, pathname} = JSON.parse(POST_LOGIN);
        localStorage.removeItem('postLogin');
        // Break out of the iframe if we are in it via a login
        if (window.top !== window.self) {
          let redirectUrl = new URL(window.location.href);
          redirectUrl.searchParams.delete('code');
          const origin = window.location.origin;
          redirectUrl = new URL(`${origin}${pathname}${search || ''}`);
          window.top.location.href = redirectUrl.toString();
        }
      } else {
        // Break out of the iframe if we are in it via a login
        if (window.top !== window.self) {
          let redirectUrl = new URL(window.location.href);
          redirectUrl.searchParams.delete('code');
          const origin = window.location.origin;
          redirectUrl = new URL(`${origin}${'/'}${QueryString.stringify(params) || ''}`);
          window.top.location.href = redirectUrl.toString();
        }
      }
    } catch (err) {
      console.error(err);
      setloginInProg(false);
    }
  }, [globalDispatch, push]);

  React.useEffect(() => {
    const {code, ...params} = QueryString.parse(search);

    if (code) {
      getAuthToken(code, params);
    }
  }, [getAuthToken, push, search]);

  return (
    <div className={S.loginContain}>
      {loginInProg && <div className={S.spinContain}><Spinner/></div>}
      {!loginInProg &&
        <iframe
          className={S.login}
          id={'login-container'}
          data-testid={'LOGIN_IFRAME'}
          title='QAM Widget'
          height='100%'
          src={`${process.env.REACT_APP_SIGN_IN_URL}/signin?${SEARCH}`}
        >
        </iframe>
      }
    </div>
  );
};

LoginPage.displayName = 'LoginPage';
LoginPage.propTypes   = {
  history:  PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export { LoginPage };
